import { render, staticRenderFns } from "./QueryGroupExplain.vue?vue&type=template&id=05094284&scoped=true&"
import script from "./QueryGroupExplain.vue?vue&type=script&lang=js&"
export * from "./QueryGroupExplain.vue?vue&type=script&lang=js&"
import style0 from "./QueryGroupExplain.vue?vue&type=style&index=0&id=05094284&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05094284",
  null
  
)

export default component.exports